export const getProfileLabel = (status) => {
    switch (status) {
        case 'company':
            return "Empresa";
        case 'receiver':
            return "Recebedor";
        default:
            return "Desconhecido";
    }
}